<template>
  <div v-if="flashMessage" class="col-12 mt-3">
    <BootstrapFlashMessage
      type="danger"
      :dismissible="false"
    >
      {{ this.flashMessage }}
    </BootstrapFlashMessage>
  </div>

  <div class="col mt-3" v-if="$store.state.loading">
    <div class="card">
      <div class="card-header" :class="emphasisClass" v-if="emphasisClass" />
      <div class="card-body text-center">
        <BeatLoader />
      </div>
    </div>
  </div>

  <template v-else>
    <div class="col-sm-12 col-lg-6 mt-3">
      <div class="card">
        <div class="card-header" :class="emphasisClass" v-if="emphasisClass" />

        <div class="card-body">
          <h4 class="card-title">
            {{ project.title }}
          </h4>
        </div>

        <div class="row card-body">
          <div
            class="col-12 col-md-4"
          >
            <img src="~/images/logo.svg" width="90%" alt="AISLER logo">
          </div>
          <div class="col-12 col-md-8 text-center">
            <p>
              {{ $t('ProjectShowcaseCards.publicProject') }}
            </p>
            <p>
              {{ $t('ProjectShowcaseCards.importToOrder') }}
            </p>

            <div
              class="row"
              v-if="$store.state.loggedIn"
            >
              <div class="cell text-center">
                <LoadingButton
                  class="btn btn-aisler-gradient w-100"
                  @click="triggerImport"
                  :loading="currentlyImporting"
                >
                  {{ $t('ProjectShowcaseCards.import') }}
                </LoadingButton>
              </div>
            </div>

            <div class="row" v-else>
              <div class="col col-lg-5 text-center">
                <a :href="registrationPath" class="btn btn-aisler-gradient w-100">
                  {{
                    $t('ProjectShowcaseCards.register')
                  }}
                </a>
              </div>
              <div class="col col-lg-2 text-center">
                {{ $t('ProjectShowcaseCards.or') }}
              </div>
              <div class="col col-lg-5 text-center">
                <a :href="loginPath" class="btn btn-aisler-gradient w-100">
                  {{
                    $t('ProjectShowcaseCards.login')
                  }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ProjectSpecsCard class="mt-3" />
  </template>
</template>

<script>
import ProjectSpecsCard from 'components/project/ProjectSpecsCard.vue';
import messages from 'locales/ProjectShowcaseCards';
import LoadingButton from 'components/helper/LoadingButton.vue';
import { getRequest, postRequest } from 'helper/request';
import BootstrapFlashMessage from 'components/helper/BootstrapFlashMessage.vue';
import BeatLoader from 'components/shared/BeatLoader.vue';

export default {
  name: 'ProjectShowcaseCards',
  data() {
    return {
      interval: null,
      currentlyImporting: false,
      flashMessage: null,
    };
  },
  props: {
    projectPath: String,
    registrationPath: String,
    loginPath: String,
    importPath: String,
    authenticityToken: String,
  },
  components: {
    BeatLoader,
    BootstrapFlashMessage,
    LoadingButton,
    ProjectSpecsCard,
  },
  mounted() {
    this.loadProject();
  },
  computed: {
    project() {
      return this.$store.state.project;
    },
  },
  methods: {
    loadProject() {
      const self = this;
      const { state } = this.$store;
      const request = getRequest(this.projectPath);
      request.then((data) => {
        state.loggedIn = data.loggedIn;
        state.revisions = data.revisions;
        state.cards = data.cards;
        state.board = data.board || { processed: true };
        state.project = data.project;
        state.loading = false;

        if (!state.board.processed && !self.interval) {
          self.interval = window.setInterval(self.loadProject, 4000);
        } else if (state.board.processed) {
          window.clearInterval(self.interval);
        }
      }, () => {
      });
    },
    async triggerImport() {
      this.currentlyImporting = true;
      try {
        const response = await postRequest(this.importPath);
        window.location.href = response.redirect_url;
      } catch {
        this.flashMessage = 'Import failed! Please try again or contact our support';
        this.currentlyImporting = false;
      }
    },
  },
  i18n: { messages },
};
</script>

<style></style>
